import capitalize from '@framework/data-helpers/string/capitalize';
import { ArticlesType } from '@/creditflowresearch/ui/components/creditFlow/articles/constants';
import ArticleTileFallback from './ArticleTileFallback';

import styles from './articlesTiles.module.scss';

interface IArticlesTilesFallbackProps {
  isAuthorized?: boolean,
}

const ArticlesTilesFallback = ({
  isAuthorized = false,
}: IArticlesTilesFallbackProps) => (
  <div className={ styles.wrapper }>
    { Object.values(ArticlesType).map((articlesType) => (
      <div className={ styles.tile } key={ articlesType } data-test={ `articlesTile${ capitalize(articlesType) }` }>
        <ArticleTileFallback articleType={ articlesType } isAuthorized={ isAuthorized } />
      </div>
    )) }
  </div>
);

export default ArticlesTilesFallback;
